module.exports = __webpack_public_path__ + "img/bg-widget-question.e947d14f.svg";